"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgShoppingCart = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M20 30a3 3 0 110 6 3 3 0 010-6zm12 0a3 3 0 110 6 3 3 0 010-6zm-12 2a1 1 0 100 2 1 1 0 000-2zm12 0a1 1 0 100 2 1 1 0 000-2zM15.252 12a3 3 0 012.97 2.61l.315 2.39H35a1 1 0 01.98 1.196l-1.68 8.389A2.995 2.995 0 0131.32 29H20.758a3 3 0 01-3-2.61l-1.52-11.52a1 1 0 00-.988-.87H13a1 1 0 010-2h2.252zm18.528 7H18.8l.942 7.13c.065.501.494.874 1.008.87h10.59a1 1 0 001-.806L33.78 19z",
    id: "shopping-cart_svg__a"
  }));
};

var _default = SvgShoppingCart;
exports.default = _default;